import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { price } from '../data/content';
const reassurances = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheckIcon,
  label: 'Sin excusas, sin riesgos'
}];
export function FinalCta() {
  return <section className="w-full bg-sage-dark py-20 sm:py-28" aria-labelledby="cta-final" data-id="element-29" data-mp="1jbk90547sv96">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="mx-auto flex max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-30" data-mp="1ed8yrta0ciqf">
        <span className="text-sm font-bold uppercase tracking-[0.2em] text-cream/70" data-id="element-31" data-mp="2245z08sfxrlu">
          Es tu momento
        </span>
        <h2 id="cta-final" className="mt-4 font-display text-3xl font-medium leading-tight text-cream sm:text-4xl lg:text-5xl" data-id="element-32" data-mp="1x2goqvd1lhyt">
          Tu cuerpo está esperando este pequeño primer paso.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-cream/85 sm:text-xl" data-id="element-33" data-mp="x420wf5grvg4">
          Descargá hoy el libro digital y los 3 bonos, y empezá mañana mismo con solo 15
          minutos y una silla.
        </p>

        <p className="mt-8 inline-flex items-baseline gap-3 rounded-full bg-cream/10 px-6 py-4 text-cream" data-id="element-34" data-mp="1658hspc0z89w">
          <span className="font-display text-4xl font-semibold sm:text-5xl" data-id="element-35" data-mp="1b2i3btwamzsg">
            {price.amount}
            <span className="align-top text-2xl" data-id="element-36" data-mp="1fvb9mm7eug6n">{price.currency}</span>
          </span>
          <span className="text-base text-cream/80" data-id="element-37" data-mp="1ktmj2vtsmooc">pago único</span>
        </p>

        <div className="mt-9 w-full sm:w-auto" data-id="element-38" data-mp="1pspls9mawit5">
          <CtaButton variant="light" data-id="element-39" data-mp="1pu0p68bu3ojq">Quiero empezar ahora</CtaButton>
        </div>

        <ul className="mt-8 flex flex-col items-center gap-3 text-base text-cream/80 sm:flex-row sm:gap-x-6" data-id="element-40" data-mp="1tuuff8cr1ffs">
          {reassurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-41" data-mp="3lw46blpr5md3">
              <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-42" data-mp="3ltrf0hy3tznd" />
              {label}
            </li>)}
        </ul>
      </motion.div>
    </section>;
}